import { render, staticRenderFns } from "./ProductReviewReplyForm.vue?vue&type=template&id=cf6414e4&"
import script from "./ProductReviewReplyForm.vue?vue&type=script&lang=js&"
export * from "./ProductReviewReplyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports